<script>
import { projects, projectsTitle } from "../data/projects"
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel"
import "vue3-carousel/carousel.css"

const lang = navigator.language.startsWith("pt") ? "pt" : "en"

export default {
  name: "ProjectsSection",

  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation
  },

  data() {
    return {
      projects,

      lang,

      title: projectsTitle[lang],

      visibleProjects: projects.filter(
        project => project.visible
      ),

      breakpoints: {
        0: {
          itemsToShow: 1,
          gap: 20
        },

        769: {
          itemsToShow: 2,
          gap: 100
        }
      }
    }
  }
}
</script>

<template>
  <section id="projects" class="projects">

    <div class="container">

      <div class="section-game">

        <h2 class="section-title">
          {{ title.first }}

          <span class="gradient-text">
            {{ title.second }}
          </span>
        </h2>

        <p class="section-subtitle">
          {{ title.description }}
        </p>

      </div>

      <!-- CAROUSEL (DESATIVADO) -->
      <!--
      <Carousel
        :autoplay="0"
        :pause-autoplay-on-hover="true"
        :mouse-drag="true"
        :touch-drag="true"
        :transition="500"
        loop="true"
        snap-align="start"
        :wrap-around="true"
        class="project-main"
        :breakpoints="breakpoints"
      >
        <Slide
          v-for="project in visibleProjects"
          :key="project.id || project.name"
        >
      -->

      <div class="cards-wrapper">

        <article v-for="project in visibleProjects" :key="project.id || project.name" class="game-card">

          <div class="game-image-container" :class="project.bgClass">

            <img :src="project.image || project.icon" :alt="project.name" class="game-image" />

            <span class="badge" :class="project.badgeClass">
              {{ project[lang].badge }} {{ project.year }}
            </span>

            <div class="hover-overlay">

              <div class="hover-info">

                <h3 class="game-title font-orbitron">
                  {{ project.name }}
                </h3>

                <div class="tool-list">

                  <span v-for="tag in project[lang].tags" :key="tag" class="tool-tag">
                    {{ tag }}
                  </span>

                </div>

              </div>

            </div>

          </div>

          <div class="card-body">

            <div class="store-buttons">

              <a v-if="project.available" :href="project.playstoreLink || project.link" target="_blank"
                rel="noopener noreferrer" class="store-btn store-btn-playstore">

                <img :src="project.storeIcon" class="store-icon" />

                <div class="store-text">

                  <p class="store-subtitle">
                    {{ project[lang].download }}
                  </p>

                  <p class="store-title">
                    Google Play
                  </p>

                </div>

              </a>

            </div>

          </div>

        </article>

      </div>

      <!-- CAROUSEL (FECHAMENTO) -->
      <!--
        </Slide>

        <template #addons>
          <Pagination />
          <Navigation />
        </template>
</Carousel>
-->

    </div>

  </section>
</template>

<style scoped>
.projects {
  padding: 50px 20px;
  background: var(--bg-secundario);
}

.section-game {
  text-align: center;
  margin-bottom: 40px;
}

.section-title {
  font-family: 'Orbitron', sans-serif;
  font-size: clamp(24px, 4vw, 48px);
}

.section-subtitle {
  color: var(--cor-texto-suave);
  font-size: 16px;
  max-width: 600px;
  margin: 0 auto 20px;
}

.cards-wrapper {
  display: flex;
  gap: 40px;
  justify-content: space-around;
  flex-wrap: wrap;
}

.game-card {
  width: 420px;
  background: var(--bg-destaque);
  border: 1px solid var(--card-base);
  border-radius: 20px;
  overflow: hidden;
  transition:
    transform .3s ease,
    box-shadow .3s ease,
    border-color .3s ease;
}

.game-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 0 0 20px 20px;
}

.game-image {
  width: 100%;
  max-width: 420px;
  object-fit: contain;
  border-radius: 0 0 20px 20px;
}

.purple-bg {
  background: linear-gradient(135deg,
      var(--card-base),
      var(--card-destaque));
}

.red-bg {
  background: linear-gradient(135deg,
      var(--card-secundaria),
      var(--card-destaque));
}

.badge {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  color: var(--cor-texto-principal);
  letter-spacing: 1.5px;
  z-index: 3;
}

.badge-upcoming {
  background: linear-gradient(135deg,
      var(--card-secundaria),
      var(--card-destaque));
}

.badge-released {
  background: linear-gradient(135deg,
      var(--card-secundaria),
      var(--card-destaque));
}

.hover-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top,
      rgba(18, 17, 38, 0.95),
      rgba(18, 17, 38, 0.7),
      rgba(18, 17, 38, 0.2));
  opacity: 0;
  transition: opacity .4s ease;
  display: flex;
  align-items: flex-end;
}

.game-image-container:hover .hover-overlay {
  opacity: 1;
}

.hover-info {
  padding: 20px;
  width: 100%;
  opacity: 0;
  transform: translateY(30px);

  transition:
    opacity .4s ease,
    transform .4s ease;
}

.game-image-container:hover .hover-info {
  opacity: 1;
  transform: translateY(0);
}

.card-body {
  padding: 14px;
}

.game-title {
  font-size: 30px;
  margin-bottom: 6px;
  text-align: center;
  letter-spacing: 3px;
}

.tool-list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.tool-tag {
  background: var(--card-base);
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 13px;
  letter-spacing: 1.5px;
}

.store-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}

.store-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border-radius: 12px;
  background: var(--card-destaque);
  text-decoration: none;
  border: 1px solid var(--card-base);

  transition:
    transform .25s ease,
    box-shadow .25s ease;
}

.store-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px var(--card-sombra);
}

.store-icon {
  width: 32px;
  height: 32px;
}

.store-text {
  text-align: left;
}

.store-subtitle {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--cor-texto-secundario);
  font-weight: 600;
  margin: 0;
}

.store-title {
  font-weight: bold;
  font-size: 14px;
  color: var(--cor-texto-principal);
  margin: 0;
  letter-spacing: 1.5px;
}

@media (max-width: 800px) {
  .projects {
    min-height: auto;
    padding: 30px 20px;
  }

  .cards-wrapper {
    align-items: center;
    gap: 10px;
    justify-content: center;
    flex-wrap: nowrap;
  }

  .game-card {
    width: 200px;
    max-width: 200px;
    border-radius: 16px;
  }

  .section-game {
    margin-bottom: 20px;
  }

  .section-subtitle {
    font-size: 12px;
    max-width: 400px;
  }

  .game-image-container {
    border-radius: 0 0 16px 16px;
  }

  .game-image {
    max-width: 200px;
    border-radius: 0 0 16px 16px;
  }

  .badge {
    padding: 4px 8px;
    font-size: 8px;
  }

  .hover-info {
    padding: 10px;
  }

  .card-body {
    padding: 10px;
  }

  .game-title {
    font-size: 14px;
  }

  .tool-tag {
    padding: 4px 10px;
    border-radius: 10px;
    font-size: 11px;
  }

  .store-btn {
    padding: 4px;
    border-radius: 10px;
    gap: 2px;
  }

  .store-icon {
    width: 25px;
    height: 25px;
  }

  .store-subtitle {
    font-size: 7px;
  }

  .store-title {
    font-size: 10px;
  }
}
</style>